// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2sCn_","question":"Question_question__2Juky","description":"Question_description__1oRVG"};